import { useQuery } from '@tanstack/react-query';

import type { UserPermissionsResponse } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

export const useUserPermissions = (enabled = true) =>
  useQuery({
    queryKey: extranetQueryKeys.account.permissions(),
    queryFn: () =>
      getExtranetApi().get<Record<string, never>, UserPermissionsResponse>('/v1/extranet/users/me/permissions', {}),
    enabled,
    staleTime: 60 * 1000,
  });
